module.exports = {
    DATE_FORMAT: 'DATE_FORMAT',
    DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'DATE_FORMAT_WITH_DASHES_FIRST_YEAR',
    DATE_FORMAT_DAY_MONTH: 'DATE_FORMAT_DAY_MONTH',
    FILE_UPLOAD_MAX_SIZE: 5120,
    FILE_UPLOAD_ONE_MB: 1024,
    FILE_UPLOAD_TITLE_LENGTH: 30,
    KEYBOARD_ESC: 27,
    KEYBOARD_RETURN: 13,
    NON_NUMERIC_REGEXP: /[^0-9]+/g,
    OPENBANK_PRODUCT_WEALTH: 'wealth',
    OPENBANK_PRODUCT_BANKING: 'banking',
    TRANSFER_MAX_IMPORT: 9999999.99,
    TRANSFER_MIN_IMPORT: 0,
    TYPE_ETFS: 'etfs',
    TYPE_FUNDS: 'funds',
    TYPE_PLANS: 'plans',
    TYPE_STOCKS: 'stocks',
    TYPE_WARRANTS: 'warrants',
    MAX_LENGTH_AMOUNT_INPUT: 16,
    ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEXP: /^[a-zA-ZÀ-ÿ_ñÑ_0-9-\s]*$/,
    WHITE_LIST_FILE_NAME_CHARS_REGEXP: /^[a-z0-9|\-| |_|á|é|í|ó|ú|ñ|ä|ë|ï|ö|ü|ç]+\.[a-z0-9]{3,4}$/ig
};
